import React, { useEffect } from 'react'
import { images } from 'Assets/Images'
import {
  CheckCircleFill,
  PencilSquare,
  XCircleFill,
} from 'react-bootstrap-icons'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useGetCmfCredit } from '../../../hooks/useGetCmfCredit'
import { FormatMoney } from 'Utils/functions'
import { disclaimers } from 'Views/PrinterPreview/constants'

export const DEFAULT_VALUE = disclaimers.regularCmf

export const Square5Cmf = ({ products, i }) => {
  const { currentPage, allTemplatesContent, setAllTemplatesContent } =
    usePrinterContext()

  const currentContent = allTemplatesContent.find(
    content => content.page === currentPage
  )
  const currentTerms = currentContent?.content?.terms || DEFAULT_VALUE

  const { fetchCmfCredit, loading } = useGetCmfCredit({ fetchAllTerms: true })
  const [isEditing, setIsEditing] = React.useState(false)
  const [terms, setTerms] = React.useState(currentTerms)

  const prod = products?.content?.products?.[0]
  const prodBasePrice = FormatMoney(prod?.BasePrice || 0)

  const handleEditTerms = () => {
    const updatedContent = allTemplatesContent.map(content => {
      if (content.page === currentPage) {
        return {
          ...content,
          content: {
            ...content.content,
            terms,
          },
        }
      }
      return content
    })
    setAllTemplatesContent(updatedContent)
    setIsEditing(false)
  }

  useEffect(() => {
    if (prod?.Sku && !prod?.cmfCredit) {
      fetchCmfCredit(prod?.BasePrice, prod?.Sku)
    }
  }, [prod?.Sku])

  return (
    <div
      id="printer-preview-left-canvas"
      data-testid="printer-preview-left-canvas"
      className="printer-preview-left-canvas">
      <div className="printer-preview-left-content-body">
        <p className="printer-preview-body-title-cmf">
          {prod?.ProductName || ''}
        </p>
        <p className="printer-preview-body-sku-cmf">{prod?.Sku || ''}</p>
        {prod?.BasePrice && (
          <div className="printer-preview-container-prices">
            <div className="printer-preview-content-price">
              <p
                className="printer-preview-quote-1"
                style={{
                  alignSelf: 'end',
                  marginBottom: 10,
                }}>
                36 cuotas desde
              </p>
              <div
                className="printer-preview-container-price"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 130,
                }}>
                <p className="printer-preview-price-simbol text-green-dark">
                  $
                </p>
                <p className="printer-preview-price text-green-dark">
                  {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-mini text-green-dark">
                  .{FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
            <div className="printer-preview-content-price">
              <p className="printer-preview-quote-2">24 cuotas desde</p>
              <div className="printer-preview-container-price">
                <p className="printer-preview-price-simbol-small text-green-dark">
                  $
                </p>
                <p className="printer-preview-price-small text-green-dark">
                  {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-small-mini text-green-dark">
                  .
                  {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
            <div className="printer-preview-content-price">
              <p className="printer-preview-quote-2">12 cuotas desde</p>
              <div className="printer-preview-container-price">
                <p className="printer-preview-price-simbol-small text-green-dark">
                  $
                </p>
                <p className="printer-preview-price-small text-green-dark">
                  {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-small-mini text-green-dark">
                  .
                  {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="printer-preview-left-content-footer">
        {prod?.BasePrice && (
          <div className="printer-preview-footer-container-price">
            <p className="printer-preview-footer-price">Precio regular</p>
            <p className="printer-preview-price-small">
              {!loading && '$' + prodBasePrice}
              {loading && (
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="spinner"
                  data-testid="spinner"
                  style={{ width: 20 }}
                />
              )}
            </p>
          </div>
        )}

        <div className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove">
          {isEditing && (
            <textarea
              className="printer-preview-left-content-footer-legal-1"
              type="text"
              value={terms}
              disabled={!isEditing}
              onChange={e => setTerms(e.target.value)}
              style={{
                border: isEditing ? '1px solid #000' : 'none',
                height: '30px',
              }}
            />
          )}
          {!isEditing && (
            <p
              className="printer-preview-left-content-footer-legal-1"
              style={{
                border: isEditing ? '1px solid #000' : 'none',
                height: '30px',
              }}>
              {terms}
            </p>
          )}
          <div className="printer-terms-edit-wrapper-1">
            {isEditing && (
              <CheckCircleFill
                onClick={handleEditTerms}
                data-testid="confirmEdit"
                className="printer-preview-content-check"
              />
            )}
            {isEditing && (
              <XCircleFill
                onClick={() => {
                  setIsEditing(false)
                  setTerms(DEFAULT_VALUE)
                }}
                className="printer-preview-content-circle"
              />
            )}
            {!isEditing && (
              <PencilSquare
                onClick={() => setIsEditing(true)}
                data-testid="pencil"
                className="printer-preview-content-pencil"
              />
            )}
          </div>
        </div>
      </div>
      <img
        className="printer-preview-left-image"
        src={images.printer.templates.cmf4}
        alt="template-preview"
      />
    </div>
  )
}
